import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getIsOpen, getNewQuestionFormStep } from '../../selectors/newQuestion';
import { ENewQuestionModalStep } from '../../types/newQuestion';
import { setNewQuestionFormClose } from '../../actions/newQuestion';
import { getIsAgent } from '../../selectors/user';
import { RejectionForBuilder } from '../../components/RejectionForBuilder';
import { NewQuestionModalContentContainer } from '../NewQuestionModalContent';
import { NewQuestionFooterContainer } from '../NewQuestion/NewQuestionFooterContainer';
import { ELabel, ETrackingAction, trackQuestionFormAction } from '../../actions/newQuestion/tracking';
import { FormModalLayout } from '../../components/FormLayout';
import { getNewbuildingInfo } from '../../selectors/newbuildingInfo';

export const NewQuestionModalContainer = (): React.JSX.Element => {
  const dispatch = useDispatch();
  const isOpened = useSelector(getIsOpen);
  const { newbuildingName } = useSelector(getNewbuildingInfo);
  const step = useSelector(getNewQuestionFormStep);
  const isInfoLayout = step === ENewQuestionModalStep.Error || step === ENewQuestionModalStep.Success;
  const isAgent = useSelector(getIsAgent);

  const onClose = React.useCallback(() => {
    dispatch(setNewQuestionFormClose());
    switch (step) {
      case ENewQuestionModalStep.Question:
        trackQuestionFormAction(ETrackingAction.Close, ELabel.Form);
        break;
      case ENewQuestionModalStep.Error:
        trackQuestionFormAction(ETrackingAction.Close, ELabel.Error);
        break;
    }
  }, [dispatch, step]);

  if (isAgent) {
    return (
      <FormModalLayout
        testId="RejectionForBuilder"
        shortTitle="Новый вопрос"
        open={isOpened}
        onClose={onClose}
        type="info"
      >
        <RejectionForBuilder onClose={onClose} />
      </FormModalLayout>
    );
  }

  return (
    <FormModalLayout
      title={`Вопрос о ЖК «${newbuildingName}»`}
      shortTitle="Новый вопрос"
      subtitle="Он появится на странице ЖК"
      footer={<NewQuestionFooterContainer />}
      onClose={onClose}
      type={isInfoLayout ? 'info' : 'form'}
      open={isOpened}
      testId="NewQuestion"
    >
      <NewQuestionModalContentContainer step={step} onClose={onClose} />
    </FormModalLayout>
  );
};
